import { render, staticRenderFns } from "./ModalShowMessage.vue?vue&type=template&id=ef401344&"
import script from "./ModalShowMessage.vue?vue&type=script&lang=js&"
export * from "./ModalShowMessage.vue?vue&type=script&lang=js&"
import style0 from "./ModalShowMessage.vue?vue&type=style&index=0&id=ef401344&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports